<template>
<div class="main-wrapper">
  <el-scrollbar class="main-wrapper-scrollbar">
    <div class="wrapper-list">
      <div class="top-title">
        <span class="title">{{examInfo.op_name}}</span>
        <span class="title-1" style="opacity: 0">{{examInfo.op_name}}</span>
      </div>
      <img src="../../../../assets/images/student/bottom-line.png" alt="" style="width: 100%;display: block">
      <div class="time-item">
        <div class="time-item-list">
          <div class="time-title-left">
            <span class="comma" style="margin-left: 22px">,,,</span>
            <div class="item">
              <span class="score-title">本题分值：{{examInfo.score}}分</span>
              <span style="margin-left: 50px">考核时间{{examInfo.assess_time}}分钟</span>
            </div>
            <span class="comma">,,,</span>
          </div>
          <div class="start-tex" @click="startBtn()">开始考试</div>
        </div>
      </div>
      <!--S 任务目标-->
      <div class="mission-wrapper" v-if="examInfo.task_goal">
        <div class="mission-title">
          <span class="line"></span>
          <span class="mission-title-text">任务目标</span>
        </div>
        <div class="task-item" v-for="(item, index) in examInfo.task_goal" :key="index">
          <div class="task-bg">
            <img src="../../../../assets/images/student/task-bg.png" alt="">
            <p class="num-title"><em style="color: #FEDB2E">N0.1</em>任务{{item.index}}</p>
          </div>
          <div class="task-content">
            <p class="text">{{item.target}}</p>
          </div>
        </div>
      </div>
      <!--E 任务目标-->
      <!--S 任务背景-->
      <div class="mission-wrapper" v-if="examInfo.task_background">
        <div class="mission-title">
          <span class="line"></span>
          <span class="mission-title-text">任务背景</span>
        </div>
        <div class="task-item">
          <div class="task-content">
            <p class="text" v-html="examInfo.task_background"></p>
          </div>
        </div>
      </div>
      <!--E 任务背景-->
      <!--S 任务分析-->
      <div class="mission-wrapper" v-if="examInfo.task_analysis">
        <div class="mission-title">
          <span class="line"></span>
          <span class="mission-title-text">任务分析</span>
        </div>
        <div class="task-item">
          <div class="task-content">
            <p class="text" v-html="examInfo.task_analysis"></p>
          </div>
        </div>
      </div>
      <!--E 任务分析-->
      <!--S 任务操作-->
      <div class="mission-wrapper" v-if="examInfo.task_operation">
        <div class="mission-title">
          <span class="line"></span>
          <span class="mission-title-text">任务操作</span>
        </div>
        <div class="task-item">
          <div class="task-content">
            <p class="text" v-html="examInfo.task_operation"></p>
          </div>
        </div>
      </div>
      <!--E 任务操作-->
      <!--S 评分标准-->
      <div class="mission-wrapper" v-if="examInfo.scoring_criteria">
        <div class="mission-title">
          <span class="line"></span>
          <span class="mission-title-text">评分标准</span>
        </div>
        <div class="task-item">
          <div class="task-content">
            <p class="text" v-html="examInfo.scoring_criteria"></p>
          </div>
        </div>
      </div>
      <!--E 评分标准-->
    </div>
  </el-scrollbar>
</div>
</template>

<script>
import {stuOpGetExamInfo} from '@/utils/apis'
export default {
  name: "OnlineStoreFitment",
  data(){
    return {
      examInfo: {
        id: null,
        op_name: '', //名称
        score: null, //分数
        assess_time: null, //时间
        task_goal: [], //任务目标 1
        task_background: '', //任务背景 1
        task_analysis: '', //任务分析 1
        task_operation: '', //任务操作 1
        scoring_criteria: [], //评分标准 1
        file_download: '', //素材下载地址
      }
    }
  },
  mounted() {
    this.getExamStuExamPage()
  },
  methods: {
    getExamStuExamPage(){
      let params = {
        type: "shop_decoration "
      }
      if (this.$route.query.id) {
        params.op_id = this.$route.query.id;
      }
      stuOpGetExamInfo(params).then((res)=>{
        this.examInfo = res.data
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 开始考试
    startBtn(){

    }
  }
}
</script>

<style scoped lang="scss">
.main-wrapper {
  background: url("../../../../assets/images/student/student-sct-bg.png") no-repeat;
  background-size: 100% 100%;
  height: 100%;
  position: relative;
  .main-wrapper-scrollbar {
    height: 100%;
    ::v-deep > .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    .wrapper-list {
      .top-title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        font-size: 48px;
        color: #35c773;
        padding-top: 20px;
        letter-spacing: 4px;
        font-weight: bold;
        /*margin-bottom: 28px;*/
        position: relative;
        .title {
          position: absolute;
          top: 0;
        }

        &:before {
          content: url("../../../../assets/images/student/line-left.png");
          margin-right: 15px;
        }

        &:after {
          content: url("../../../../assets/images/student/line-right.png");
          margin-left: 15px;
        }

      }
      .time-item {
        /*position: absolute;*/
        /*top: 180px;*/
        margin-top: 28px;
        width: 100%;
        display: flex;
        justify-content: center;

        .time-item-list {
          display: flex;
          height: 80px;
          line-height: 80px;
          background: #39B678;

          .time-title-left {
            flex: 1;
            display: flex;
            border: 6px solid #61a885;
            background: #DDFDF2;

            .comma {
              color: #31A588;
              font-size: 66px;
              letter-spacing: 18px;
              text-align: center;
              line-height: 33px;
              display: inline-block;
            }

            .item {
              flex: 1;
              font-size: 24px;
              padding: 0 40px;
              color: #31A588;
              position: relative;

              &:after {
                content: '';
                height: 40px;
                width: 3px;
                background: #31A588;
                position: absolute;
                top: 14px;
                right: 10px;
              }

              &:before {
                content: '';
                height: 40px;
                width: 3px;
                background: #31A588;
                position: absolute;
                top: 14px;
                left: 10px;
              }
            }
          }

          .start-tex {
            width: 120px;
            font-size: 24px;
            color: #fff;
            cursor: pointer;
            text-align: center;
          }
        }

      }
    }
    .mission-wrapper {
      width: 100%;
      .mission-title {
        width: 100%;
        height: 80px;
        text-align: center;
        font-size: 48px;
        font-style: italic;
        font-weight: 600;
        position: relative;
        margin-top: 40px;

        .line {
          position: absolute;
          top: 40px;
          left: calc(50% - 150px);
          width: 300px;
          height: 20px;
          background: #FEDB2E;
        }

        .mission-title-text {
          position: inherit;
          /*left: calc(50% - 100px);*/
          text-align: center;
        }
      }

      .task-item {
        margin-top: 36px;
        .task-bg {
          color: #fff;
          position: relative;
          margin-left: 50px;

          .num-title {
            font-size: 34px;
            position: absolute;
            top: -26px;
            left: 50px;

            em {
              font-style: normal;
            }

          }
        }

        .task-content {
          background: #DDFDF2;
          padding: 20px 20px 20px 50px;
          margin: -20px 20px;
          ::v-deep {
            img {
              max-width: 100%;
            }
            p {
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>